module.exports = __webpack_public_path__ + "img/map.807d06d7.svg";